import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Suspense, lazy } from 'react';
import { LoginGate, useAuth } from '@/shared/auth';

// Lazy load devtools pouze v development
const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import('@tanstack/react-router-devtools').then((mod) => ({
        default: mod.TanStackRouterDevtools,
      }))
    );

/**
 * Kořenová route aplikace.
 * Všechny ostatní routes jsou potomky této route.
 */
export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const auth = useAuth();

  if (auth.status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center">
        <span className="text-muted-foreground text-sm">Načítám...</span>
      </div>
    );
  }

  if (auth.status === 'unauthenticated') {
    return <LoginGate />;
  }

  if (auth.status === 'error') {
    return (
      <div className="flex h-screen items-center justify-center">
        <span className="text-destructive text-sm">{auth.message}</span>
      </div>
    );
  }

  return (
    <>
      <Outlet />
      {import.meta.env.VITE_DEVTOOLS === 'true' ? (
        <Suspense fallback={null}>
          <TanStackRouterDevtools position="bottom-right" />
        </Suspense>
      ) : null}
    </>
  );
}
